
    import './styles.scoped.css';
    export default {
  "content-wrapper": "awsui_content-wrapper_zycdx_bi5ka_3",
  "content-wrapper-refresh": "awsui_content-wrapper-refresh_zycdx_bi5ka_7",
  "content-wrapper-no-navigation-padding": "awsui_content-wrapper-no-navigation-padding_zycdx_bi5ka_10",
  "content-wrapper-no-tools-padding": "awsui_content-wrapper-no-tools-padding_zycdx_bi5ka_13",
  "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_bi5ka_16"
};
  